'use client';

import { forwardRef } from 'react';

import { AccordionItemProvider } from '../contexts/accordion-item-context';
import { useAccordionItem, UseAccordionItemProps } from '../hooks/use-accordion-item';

export interface AccordionItemProps extends UseAccordionItemProps {
	children: React.ReactNode;
}

interface AccordionItem {
	itemKey: string;
}

export const AccordionItem = forwardRef<HTMLElement, AccordionItemProps>(function AccordionItem(
	props, 
	ref
) {
	const {
		Component,
		itemKey,
		getBaseProps,
	} = useAccordionItem(props);

	return (
		<AccordionItemProvider itemKey={itemKey}>
			<Component
				ref={ref}
				{...getBaseProps(props)}
			/>
		</AccordionItemProvider>
	);
});